var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"ui very basic fixed table"},[_vm._m(0),_c('tbody',_vm._l((_vm.hashlinkModels),function(hashlinkModel){return _c("table-row",{key:hashlinkModel.id,tag:"tr",attrs:{"hashlink-model":hashlinkModel}})}),1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("Erstellt am")]),_c('th',[_vm._v("Gültig bis")]),_c('th')])])
}]

export { render, staticRenderFns }